import { useContext, useEffect, useMemo, useState } from 'react'

import {
  Box,
  Button,
  DragNDrop,
  Icon,
  Modal,
  Text,
} from '@fairfashion/design-system'

import { sdk } from '../../services/sdk'
import { ConfirmModalContext } from '../ConfirmModal'

import * as Styles from './evidence-form.styles'
import { EvidenceFormProps } from './evidence-form.types'

export const EvidenceForm = ({
  onSubmit,
  open,
  setOpen,
  data,
  onRemoveEvidence,
}: EvidenceFormProps) => {
  const [file, setFile] = useState<File>()
  const [uploading, setUploading] = useState(false)

  const { confirmModal } = useContext(ConfirmModalContext)

  useEffect(() => {
    if (!open) {
      setFile(undefined)
      setUploading(false)
    }
  }, [open])

  const onSubmitEvidence = async () => {
    if (!file) return

    setUploading(true)

    const url = await sdk.items.uploadItemEvidence(file)

    onSubmit({ name: file.name, file: url })
    setOpen(false)
    setFile(undefined)
    setUploading(false)
  }

  const isEmpty = useMemo(() => {
    return !data?.evidence?.files?.length
  }, [data])

  const handleRemoveEvidence = async (index: number) => {
    if (
      await confirmModal(
        'Remover arquivo',
        'Você tem certeza que deseja remover esse arquivo?',
      )
    ) {
      onRemoveEvidence(index)
    }
  }

  return (
    <>
      {!isEmpty && (
        <Box width="100%" direction="column" gap={3}>
          <Box direction="column" gap={2}>
            {data?.evidence?.files?.map((file, index) => (
              <Box
                key={file.name}
                border={{
                  width: 1,
                  color: 'grey_4',
                }}
                borderRadius="12px"
                overflow="hidden"
                alignItems="center"
              >
                <a href={file.file} target="_blank" rel="noreferrer">
                  <Styles.EvidenceTag>
                    <Text size="small" color="grey_2">
                      {file.name}
                    </Text>
                  </Styles.EvidenceTag>
                </a>
                <Box justifyContent="center" alignItems="center" width="40px">
                  <Button
                    variant="text"
                    padding="0"
                    onClick={() => handleRemoveEvidence(index)}
                  >
                    <Icon name="close" size={20} color="grey_3" />
                  </Button>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      )}
      <Modal
        open={open}
        onClose={setOpen}
        maxWidth="830px"
        width="100%"
        customTitle={
          <Text textTransform="uppercase" size="small" color="grey_3">
            Adicionar uma evidência
          </Text>
        }
      >
        <Box width="100%" direction="column" padding={1}>
          <Box direction="column" width="100%" gap={2}>
            <Box width="100%">
              {open && (
                <DragNDrop
                  onChange={(files) => setFile(files?.[0])}
                  fileType=".pdf, .png, .jpg, .jpeg, .webp, application/pdf, image/png, image/jpeg, image/webp"
                  fileTypeError="Tipo de arquivo inválido"
                />
              )}
            </Box>

            <Box width="100%" alignItems="flex-end" direction="column" gap={2}>
              <Box gap={2}>
                <Button variant="outlined" onClick={() => setOpen(false)}>
                  Cancelar
                </Button>
                <Button
                  onClick={onSubmitEvidence}
                  disabled={!file}
                  loading={uploading}
                  width="100px"
                >
                  Salvar
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}
